import React, { useContext, useEffect, useMemo, useState } from 'react';

import Chip from '@material-ui/core/Chip';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import ArchiveItemButton from '../_common/ArchiveItemButton';
import AuthContext from '../../../services/firebase/AuthContext';
import FireDataContext from '../../../services/firebase/FireDataContext';
import { formatTimeStamp } from '../../../app/common/ui/DateTools';
import getStateColour from '../../../app/colours';
import Grid from '@material-ui/core/Grid'
import JobData from '../_common/JobData';
import Spacer from '../../../app/common/ui/Spacer';

const MemberTimesheetCard = ({ timesheet }) => {
    const db = useContext(FireDataContext);
    const { currentUser } = useContext(AuthContext);
    const api = useMemo(() => new JobData({ db, currentUser }), [db, currentUser]);

    const [digest, setDigest] = useState();

    useEffect(() => {
        (async () => {

            setDigest(await api.timesheet({ timesheetId: timesheet.id }));

            // if (timesheet.bookingPath) {
            //     const booking = await db.get({ path: timesheet.bookingPath });
            //     setDigest({
            //         organization: booking?.request?.organization,
            //         bookingReference: booking?.referral?.bookingReference,
            //         courtCaseNumber: booking?.courtCase?.courtCaseNumber
            //     });
            // }
            // else if (timesheet.quotePath) {
            //     const quote = await db.get({ path: timesheet.quotePath });
            //     setDigest(quote.digest);
            // }
        })();
    }, [api, timesheet.id])

    if (!digest) return <></>;

    const status = timesheet.submitted ? 'submitted' : 'draft';

    return (
        <Paper style={{ padding: '1rem', marginBottom: '1rem' }}>
            <Grid container spacing={1}>
                <Grid item><Typography variant="button" color="textSecondary">INVOICE</Typography></Grid>
                <Grid item style={{ marginLeft: 'auto' }}><Chip label={status} size="small" style={{ backgroundColor: getStateColour(status), color: 'white' }} /></Grid>
            </Grid>
            <Typography variant="subtitle2">For {digest.client.name}</Typography>
            <Typography variant="subtitle2" color="textSecondary">Reference {timesheet.bookingReference}</Typography>
            <Typography variant="subtitle2" color="textSecondary">Court Case Number {digest.courtCase.courtCaseNumber}</Typography>
            <Spacer space='0.5rem' />
            <Typography variant="caption">Updated {formatTimeStamp(timesheet.ts)}</Typography>
            <Spacer space='0.5rem' />
            <Grid container spacing={1}>
                <Grid item>
                    <Link href={`/casework/timesheets/${timesheet.id}`} color="primary">Edit / View</Link>
                </Grid>
                <Grid item style={{ marginLeft: 'auto' }}>
                    <ArchiveItemButton doc={timesheet} docType="invoice" />
                </Grid>
            </Grid>
        </Paper>
    );
}

export default MemberTimesheetCard;